import { createBrowserRouter } from "react-router-dom";
import {
  LoginPage,
  HomePage,
  Monitoring,
  PerawatanAset,
  PerawatanBangunan,
  AuditKeamanan,
  PerawatanIt,
  InventarisLab,
  PenggunaanLab,
  AtkPage,
  InventarisAset,
  StatistikPage,
  CoePage,
  StockCardPage,
  MaterialOut
} from "../pages";
import ProtectedRoute from "../layout/ProtectedRoute";
import MainLayout from "../layout/MainLayout";
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "/coe",
        element: <CoePage />,
      },
      {
        path: "/perawatan-aset",
        element: <PerawatanAset />,
      },
      {
        path: "/monitoring",
        element: <Monitoring />,
      },
      {
        path: "/perawatan-bangunan",
        element: <PerawatanBangunan />,
      },
      {
        path: "/audit-keamanan",
        element: <AuditKeamanan />,
      },
      {
        path: "/perawatan-it",
        element: <PerawatanIt />,
      },
      {
        path: "/inventaris-lab",
        element: <InventarisLab />,
      },
      {
        path: "/penggunaan-lab",
        element: <PenggunaanLab />,
      },
      {
        path: "/atk",
        element: <AtkPage />,
      },
      {
        path: "/inventaris",
        element: <InventarisAset />,
      },
      {
        path: "/statistik",
        element: <StatistikPage />,
      },
      {
        path: "/kartu-persediaan",
        element: <StockCardPage />,
      },
      {
        path: "/material-keluar",
        element: <MaterialOut />,
      },
    ],
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
]);
export default router;
